import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  adminApi,
  InviteCompanyAdminsRequest,
  InviteCompanyAdminsResponse
} from 'services/adminApi';

/**
 * Hook to invite admins to the current user's company
 * Company context is automatically determined by the backend from authentication
 */
export const useInviteCompanyAdmins = (
  options?: UseMutationOptions<
    InviteCompanyAdminsResponse,
    Error,
    InviteCompanyAdminsRequest
  >
) => {
  return useMutation<InviteCompanyAdminsResponse, Error, InviteCompanyAdminsRequest>({
    mutationFn: (data: InviteCompanyAdminsRequest) =>
      adminApi.inviteCompanyAdmins(data),
    ...options,
  });
};
